import type { TranslationsFileType } from '@/locales'

export default {
  // Groups
  'groups.dropdown.name': `Group {number} of {mentorFullName}`,
  'groups.dropdown.newGroup': 'Search for a new mentoring group',
  'groups.settingsModal.title': `Mentoring group settings 🛠️`,
  'groups.settingsModal.name.label': `Group name`,
  'groups.settingsModal.name.placeholder': `Group name`,
  'groups.settingsModal.success': `Group settings have been successfully updated!`,

  // Admin dashboard
  'admin.dashboard.loading': `Loading dashboard...`,
  'admin.dashboard.unavailable': `The dashboard is not available for this program.`,
  'admin.dashboard.feedback.title': `Session tracking`,
  'admin.dashboard.general.title': `Participants`,
  'admin.dashboard.sessions.title': `Session tracking`,
  'admin.dashboard.feedback.sessionsPerGroupGoal': `Sessions per group goal`,
  'admin.dashboard.feedback.finishedSessions': `Completed sessions`,
  'admin.dashboard.feedback.totalReviews': `Total number of reviews`,
  'admin.dashboard.common.nbMentors': `%*mentor*%s`,
  'admin.dashboard.common.nbMentees': `%*mentee*%s`,
  'admin.dashboard.common.nbGroups': `Groups`,
  'admin.dashboard.common.nbMenteesPerMentor': `%*mentee*%s per %*mentor*% ratio`,
  'admin.dashboard.feedback.averageSessionsRating': `Average session ratings`,
  'admin.dashboard.feedback.mentorsThatLeaveFeedback': `%*mentor*%s who left feedback`,
  'admin.dashboard.feedback.menteesThatLeaveFeedback': `%*mentee*%s who left feedback`,
  'admin.dashboard.matching.title': `Matching tracking`,
  'admin.dashboard.matching.nbMatching': `Number of matches`,
  'admin.dashboard.matching.ofGoalReached': `Of the goal reached`,

  // Admin groups
  'admin.groups.addGroup': 'Create a group',
  'admin.groups.table.header.name': 'Name',
  'admin.groups.table.header.mentor': '%*mentor*%',
  'admin.groups.table.header.mentees': '%*mentee*%s',
  'admin.groups.table.header.finishedSessions': 'Completed sessions',
  'admin.groups.table.header.actions': 'Actions',
  'admin.groups.table.nbMentees.value.any': 'Any number of %*mentee*%s',
  'admin.groups.table.nbMentees.value': `With {count} %*mentee*% | With {count} %*mentee*%s`,
  'admin.groups.groupStructureModal.existing.title': `Add or remove<br/>users from this group 👥`,
  'admin.groups.groupStructureModal.new.title': `Create a new<br/>mentoring group 👥`,
  'admin.groups.groupStructureModal.body.addManager': `Add a manager`,
  'admin.groups.groupStructureModal.body.addMentor': `Add a %*mentor*%`,
  'admin.groups.groupStructureModal.body.addMentee': `Add a %*mentee*%`,
  'admin.groups.groupStructureModal.new.sucess': `The group has been successfully created!`,
  'admin.groups.groupStructureModal.existing.sucess': `The group has been successfully updated!`,
  'admin.groups.groupStructureModal.matching.title': `Analysis of the connection:`,
  'admin.groups.matchingSuggestions.searching': `Searching for compatible mentors...`,
  'admin.groups.matchingSuggestions.searchingMentees': `Searching for compatible mentees...`,
  'admin.groups.matchingSuggestions.title': `{count} compatible mentor found | {count} compatible mentors found`,
  'admin.groups.matchingSuggestions.titleMentees': `{count} compatible mentee found | {count} compatible mentees found`,
  'admin.groups.matchingSuggestions.compatible': `compatible`,
  'admin.groups.matchingSuggestions.selectButton': `Select this mentor`,
  'admin.groups.matchingSuggestions.selectMentor': `Select this mentor`,
  'admin.groups.matchingSuggestions.selectMentee': `Select this mentee`,
  'admin.groups.matchingSuggestions.manualSearch': `or search manually`,
  'admin.groups.matchingSuggestions.noGroup': `No group`,
  'admin.groups.matchingSuggestions.groupCount': `{count} group | {count} groups`,

  // Admin Settings
  'admin.settings.form.colorContrast.warning':
    'This color does not meet the required 4.5:1 contrast (WCAG 1.4.3) — currently {ratio}:1. Suggested:',
  'admin.settings.form.colorContrast.accept': 'Use this color',

  // Admin Reminders
  'admin.reminders.title': `Reminders`,
  'admin.reminders.cycle-periods': `Reminder period from {startDate} to {endDate}`,
  'admin.reminders.reminderStructureModal.new.title': `Create a new reminder cycle 📅`,
  'admin.reminders.reminderStructureModal.existing.title': `Add or remove reminders 📅`,
  'admin.reminders.addReminder': `Create a reminder`,
  'reminder.newReminderModal.generalInformation.input.name.label': `Reminder name`,
  'reminder.newReminderModal.generalInformation.input.name.placeholder': `Enter a name for this reminder`,
  'reminder.newReminderModal.generalInformation.input.program.label': `Program`,
  'reminder.newReminderModal.generalInformation.input.type.label': `Reminder type`,
  'reminder.newReminderModal.generalInformation.input.type.placeholder': `Select a reminder type`,
  'reminder.newReminderModal.generalInformation.input.start-date.label': `Start date`,
  'reminder.newReminderModal.generalInformation.input.start-date.placeholder': `03-12-2024`,
  'admin.reminders.reminderStructureModal.startDate.error': `The start date cannot be modified because this reminder cycle has already started.`,
  'reminder.newReminderModal.generalInformation.input.end-date.label': `End date`,
  'reminder.newReminderModal.generalInformation.input.end-date.placeholder': `03-12-2024`,
  'reminder.newReminderModal.generalInformation.input.reminder-date.label': `Reminder date`,
  'reminder.newReminderModal.generalInformation.input.reminder-date.placeholder': `03-12-2024`,
  'reminder.newReminderModal.generalInformation.buton.reminder-date': `Add a reminder date`,
  'admin.newReminderModal.submit': `Create reminder`,
  'admin.updateReminderModal.submit': `Edit reminder`,
  'admin.reminders.reminderStructureModal.new.success': `The reminder cycle has been successfully created!`,
  'admin.reminders.reminderStructureModal.update.success': `The reminder cycle has been successfully updated!`,
  'admin.reminders.reminderStructureModal.delete.success': `The reminder cycle has been successfully deleted!`,
  'admin.reminders.delete.confirmation.title': `Are you sure you want to delete this cycle?`,
  'admin.reminders.delete.confirmation.content': `This action is irreversible and will also delete all associated reminders.`,

  // admin users
  'admin.users.manualInvitationModal.title': `Manual invitation of a user<br/>using their email 📧`,
  'admin.users.manualInvitationModal.alreadyInsideProgram': `This user is already in the program.`,
  'admin.users.manualInvitationModal.add': `Add to this program`,
  'admin.users.manualInvitationModal.invite': `Send invitation`,
  'admin.users.manualInvitationModal.invitation.success': `The invitation has been sent successfully!`,
  'admin.users.manualInvitationModal.add.success': `The user has been added successfully!`,
  'admin.users.listing.searchPlaceholder': `Email, last name, first name...`,
  'admin.users.listing.all': `All`,
  'admin.users.listing.withGroup': `With group`,
  'admin.users.listing.withoutGroup': `Without group`,
  'admin.users.listing.withOrWithoutGroup': `With/without group`,
  'admin.users.excelConfirmationModal.addUser': `Add`,
  'admin.users.excelConfirmationModal.title': `Is the import <br/>correct? `,
  'admin.users.excelConfirmationModal.key.email': `Email`,
  'admin.users.excelConfirmationModal.key.firstname': `First name`,
  'admin.users.excelConfirmationModal.key.lastname': `Last name`,
  'admin.users.excelConfirmationModal.key.role': `Role`,
  'admin.users.excelConfirmationModal.key.phone': `Phone`,
  'admin.users.excelConfirmationModal.key.language': `Language`,
  'admin.users.excelConfirmationModal.key.programId': `Program`,
  'admin.users.excelConfirmationModal.key.matchingCriteria': `Matching criteria`,
  'admin.users.excelConfirmationModal.key.sso': `Single Sign-On (SSO)`,
  'admin.users.excelConfirmationModal.key.description': `Profil description`,
  'admin.users.excelConfirmationModal.success': `Users have been imported successfully!`,
  'admin.users.excelImportModal.title': `Import users<br/>from an Excel file 📂`,
  'admin.users.excelImportModal.importation.inProgress': `Import in progress...`,
  'admin.users.excelImportModal.file.valid': `Valid file`,
  'admin.users.excelImportModal.instructions.title': `How should I structure my Excel file?`,
  'admin.users.excelImportModal.instructions.body.part1': `Please download the `,
  'admin.users.excelImportModal.instructions.body.linkToTheGuide': `our guide`,
  'admin.users.excelImportModal.instructions.body.part2': ` to be filled in for importing your users. For more information on file structure, please consult `,
  'admin.users.excelImportModal.instructions.body.downloadExcel': `preformatted template`,
  'admin.users.excelImportModal.instructions.body.sentenceFileImport': `Import users program`,
  'admin.users.excelImportModal.error.invalidEmailFor': `The email is invalid for {firstName} {lastName}.`,
  'admin.users.excelImportModal.error.invalidEmailForOne': `some emails are invalid.`,
  'admin.users.excelImportModal.error.invalidUUID': 'The field {field} contains an invalid UUID: {uuid}',
  'admin.users.excelImportModal.error.invalidPhoneFor': `The phone number is invalid for {firstName} {lastName}.`,
  'admin.users.excelImportModal.error.missingColumns': `One or more columns are missing`,
  'admin.users.excelImportModal.error.missingEmailFor': `The email is missing for {firstName} {lastName}.`,
  'admin.users.excelImportModal.error.missingEmailForOne': `some emails are missing.`,
  'admin.users.excelImportModal.error.invalidRoleForOne': `Some roles are invalid.`,
  'admin.users.excelImportModal.error.invalidRoleFor': `The role is invalid for {firstName} {lastName}.`,
  'admin.users.excelImportModal.error.missingRoleForOne': `some roles are missing.`,
  'admin.users.excelImportModal.error.missingRoleFor': `The role is missing for {firstName} {lastName}.`,
  'admin.users.excelImportModal.validStructure': `The file structure is valid`,
  'admin.users.import.confirmation.title': `You are about to add "{menteeName}"<br/>to the program "{programName}"`,
  'admin.users.user.inAGroup': `In a group`,
  'admin.users.user.superAdmin': `Super admin`,
  'admin.users.user.withoutGroup': `Without group`,
  'admin.users.table.header.user': `User`,
  'admin.users.table.header.role': `Role`,
  'admin.users.table.header.group': `Group`,
  'admin.users.table.header.actions': `Actions`,
  'moreActions.user.loginMethod.sso': 'Sign-in: SSO',
  'moreActions.user.loginMethod.password': 'Sign-in: e-mail + password',
  'moreActions.user.loginMethod.pending': 'Sign-in: invitation pending',
  'moreActions.user.switchToSsoLogin': 'Switch to SSO',
  'moreActions.user.switchToSsoLogin.confirmTitle': 'Switch this account to SSO?',
  'moreActions.user.switchToSsoLogin.confirmLabel':
    'This person will sign in with their institution account, using their current e-mail address. Their password will stop working. If this address is not the institution one (a Gmail address, for example), they will no longer be able to sign in.',
  'moreActions.user.switchToSsoLogin.success':
    'The account now signs in with SSO. On the sign-in page, the person will use their institution button.',
  'moreActions.user.switchToSsoLogin.alreadySso': 'This account already signs in with SSO.',
  'moreActions.user.switchToSsoLogin.ssoDisabled': 'SSO is not enabled on this platform.',
  'moreActions.user.switchToSsoLogin.identityInUse':
    'Another account is already linked to SSO with this address. Contact the Constel team.',
  'admin.users.table.empty': `No users found.`,
  'admin.users.editUserModal.title': `Edit user`,
  'admin.users.editUserModal.save': `Save changes`,
  'admin.users.editUserModal.success': `User updated successfully!`,
  'admin.users.editUserModal.confirmation.title': `Update {userName}?`,
  'admin.users.editUserModal.email.hint': `Fix the address if it has a typo: the user will sign in with the new one.`,
  'admin.users.editUserModal.email.alreadyUsed': `This address is already used by another account`,
  'admin.users.editUserModal.email.reserved': `Only the Constel team can set or change a Constel team address`,
  'admin.users.editUserModal.rolesLocked': `A super admin's admin and support roles are managed from "My platform"`,
  'admin.users.editUserModal.superAdminHint': `Super admin: only the mentor and mentee roles can be changed here.`,

  // Matching
  'matching.newMatchingModal.matchingInformation.title': `Search for a<br/>new mentoring group 🧑‍🏫`,
  'matching.newMatchingModal.matchingInformation.bodyInformation': `
        <span>
        <strong>Would you like to be matched with a new %*mentor*% to deepen your knowledge on another topic?</strong>
        </span>
        <br />
        <br />
        <span>Click continue and fill in your new matching criteria.</span>
  `,
  'matching.newMatchingModal.fillCriteria.title': `Fill in your new<br/>matching criteria 🔎`,
  'matching.newMatchingModal.fillCriteria.bodyInformation': `
         <span>
          <strong>
            Help us match you with the %*mentor*% who suits you best by filling in these criteria:
          </strong>
          <br/>
        </span>
        <span>
            Note: Your %*mentor*% will be able to see these criteria.
        </span>
        `,
  'matching.newMatchingModal.fillCriteria.button.lookForMentor': `Search for a %*mentor*%`,
  'matching.newmatchingModal.fillCriteria.error.noAvailableMentor': `No %*mentor*% is available at the moment. Please try again later.`,
  'matching.menteeMatchingLoading.title': `We are searching for %*mentor*%s<br/>best suited to your profile...`,
  'matching.menteeMatchingLoading.steps.0': `Analyzing your profile...`,
  'matching.menteeMatchingLoading.steps.1': `Searching for compatible %*mentor*%s...`,
  'matching.menteeMatchingLoading.steps.2': `Evaluating matches...`,
  'matching.menteeMatchingLoading.steps.3': `Comparing profiles...`,
  'matching.menteeMatchingLoading.steps.4': `Ranking the best results...`,
  'matching.menteeMatchingLoading.steps.5': `Checking availability...`,
  'matching.menteeMatchingLoading.steps.6': `Optimizing recommendations...`,
  'matching.menteeMatchingLoading.steps.7': `Refining suggestions...`,
  'matching.menteeMatchingLoading.steps.8': `Preparing your results...`,
  'matching.menteeMatchingLoading.steps.9': `Finalizing, just a few more moments...`,
  'matching.menteeMatchingLoading.steps.10': `Almost done, thanks for your patience...`,
  'matching.menteeMatchingLoading.steps.11': `Final adjustments in progress...`,
  'matching.newMatchingModal.confirmation.title': `Here are our recommendations 🎉`,
  'matching.newMatchingModal.confirmation.headerSubInfo': `If you accept this new %*mentor*%, you will be placed in a new mentoring group and you will keep all the others.`,
  'matching.newMatchingModal.confirmation.cancel': `You have canceled the matching with this %*mentor*%.`,
  'matching.newMatchingModal.confirmation.success': 'You have been matched with a new %*mentor*%!',
  'matching.newMatchingModal.confirmation.error': 'You can not be matched yet, please wait a few minutes',

  'matching.matchingCriteria': 'Matching criteria',
  'matching.mentorDescription': 'Mentor description',
  'matching.findMentor': 'Find a mentor',
  'matching.newMatchingModal.confirmation.loadingProfile': `Loading %*mentor*% profile...`,
  'matching.newMatchingModal.confirmation.loadingProfile.error': `An error occurred while loading the %*mentor*%'s profile.`,
  'matching.newMatchingModal.confirmation.button.accept': `Choose this %*mentor*%`,
  'matching.newMatchingModal.confirmation.button.change': `Start a new search`,
  'matching.noMentorFoundModal.title': `We couldn't find a mentor matching your criteria 🤷`,
  'matching.noMentorFoundModal.button.restartResearch': `Rerun your search`,
  'matching.noMentorFoundModal.body.part1.1': `<strong>Your search did not yield results.</strong>`,
  'matching.noMentorFoundModal.body.part2.1': `Rerun your search by refining your criteria.`,
  'matching.noMentorFoundModal.body.part1.2': `<strong>Your search produced no matches.</strong>`,
  'matching.noMentorFoundModal.body.part2.2': `Rerun your search by broadening your criteria.`,
  'matching.noMentorFoundModal.body.part1.3': `<strong>Rest assured, your request has been taken into account.</strong><br/>You will be contacted shortly to help you with your procedures.`,
  'matching.noMentorFoundModal.body.part2.3': `To optimize the results, we recommend that you proceed with new searches to broaden the possibilities of matching.`,
  'matching.fillingCriterias.programDetails': `About the {program} program`,
  'matching.fillingCriterias.mandatory.mentor.title': `Your criteria are complete, just validate them ✅ | {count} more answer to be paired with your %*mentee*%s 🎓 | {count} more answers to be paired with your %*mentee*%s 🎓`,
  'matching.fillingCriterias.mandatory.mentee.title': `Your criteria are complete, just validate them ✅ | {count} more answer to meet your %*mentor*% 🧑‍🏫 | {count} more answers to meet your %*mentor*% 🧑‍🏫`,
  'matching.fillingCriterias.mandatory.mentor.body': `Without these answers, we cannot assign you a %*mentee*%. Your %*mentee*%s will be able to see these criteria.`,
  'matching.fillingCriterias.mandatory.mentee.body': `Without these answers, we cannot pair you with a %*mentor*%. Your %*mentor*% will be able to see these criteria.`,
  'matching.fillingCriterias.missingFields': `Missing: {fields}`,
  'matching.fillingCriterias.blockingChoice.single': `One choice only. You will only see %*mentor*%s who made the same choice.`,
  'matching.fillingCriterias.blockingChoice.multiple': `Several choices allowed.`,
  'matching.fillingCriterias.validation.allFieldsRequired': `All fields are required. Missing: {fields}`,
  'matching.fillingCriterias.mentor.title': `You don't have any %*mentee*%s for this program yet!🎓<br/>Let's fix that!`,
  'matching.fillingCriterias.mentee.title': `You don't have a %*mentor*% for this program yet!🧑‍🏫<br/>Let's fix that!`,
  'matching.fillingCriterias.mentor.body': `
        <span>
          <strong>
            Help us match you with the %*mentee*%s who suit you best by filling in these criteria:
          </strong>
          <br/>
        </span>
        <span>
            Note: Your %*mentee*%s will be able to see these criteria.
        </span>
        `,
  'matching.fillingCriterias.mentee.body': `
        <span>
          <strong>
            Help us match you with the %*mentor*% who suits you best by filling in these criteria:
          </strong>
          <br/>
        </span>
        <span>
            Note: Your %*mentor*% will be able to see these criteria.
        </span>

        `,
  'matching.fillingCriterias.button.fillCriterias': `Validate my criteria`,
  'matching.fillingCriterias.button.lookForMentor': `Search for a %*mentor*%`,
  'matching.fillingCriterias.button.saveCriteria': `Save my criteria`,
  'matching.fillingCriterias.success': `Your matching criteria have been successfully updated!`,
  'matching.fillingCriterias.noMentorAvailable': `No %*mentor*% is available at the moment. Please try again later.`,
  'matching.fillingCriterias.noMentorMatching': `No %*mentor*% matches your matching criteria. Please try again later.`,
  'matching.fillingCriterias.validation.atLeastOneField': `Please fill in at least one matching field.`,
  'matching.confirmMentorModal.text': `By continuing you will be assigned to {firstName} {lastName}`,
  'matching.confirmMentorModal.title': `Confirm your choice`,

  // Dashboard
  'dashboard.mentor.programCriterias.title': `Your mentor matching criteria`,
  'dashboard.mentor.programCriterias.button.modifyCriterias': `Modify`,
  'dashboard.mentor.programCriterias.button.addCriterias': `Fill in my criteria`,
  'dashboard.mentor.programCriterias.empty.noCriterias': `You don't have any matching criteria yet`,
  'dashboard.mentor.programCriterias.noProgram': `You don't have a mentoring program yet.`,
  'dashboard.mentor.programCriteriasModal.title': `Modify my matching criteria ✏️`,
  'dashboard.mentor.programCriteriasModal.bodyInformation': `Modify your criteria if you want to adjust the profiles of %*mentee*%s with whom you can be matched.`,
  'dashboard.mentor.programCriteriasModal.noCriterias': `You don't have any matching criteria yet.`,
  'dashboard.mentor.programCriteriasModal.success': `Your matching criteria have been successfully updated!`,

  // Dashboard Mentee Criterias
  'dashboard.mentee.programCriterias.title': `Your %*mentee*% matching criteria`,
  'dashboard.mentee.programCriterias.button.modifyCriterias': `Modify`,
  'dashboard.mentee.programCriterias.button.addCriterias': `Fill in my criteria`,
  'dashboard.mentee.programCriterias.empty.noCriterias': `You don't have any matching criteria yet`,
  'dashboard.mentee.programCriterias.noProgram': `You don't have a mentoring program yet.`,
  'dashboard.mentee.programCriteriasModal.title': `Modify my matching criteria ✏️`,
  'dashboard.mentee.programCriteriasModal.bodyInformation': `Modify your criteria if you want to adjust the profiles of %*mentor*%s with whom you can be matched.`,
  'dashboard.mentee.programCriteriasModal.noCriterias': `You don't have any matching criteria yet.`,
  'dashboard.mentee.programCriteriasModal.success': `Your matching criteria have been successfully updated!`,

  // Dashboard Unified Matching Criterias (Accordion)
  'dashboard.matchingCriterias.title': `Your matching criteria`,
  'dashboard.matchingCriterias.mentorSection': `%*mentor*%`,
  'dashboard.matchingCriterias.menteeSection': `%*mentee*%`,
  'dashboard.matchingCriterias.button.modify': `Modify`,
  'dashboard.matchingCriterias.button.add': `Fill in my criteria`,
  'dashboard.matchingCriterias.empty.noCriterias': `You don't have any matching criteria yet`,

  'dashboard.shared.groups.title': `Your groups`,
  'dashboard.shared.groups.noGroup': `You don't have any groups yet.`,
  'dashboard.shared.groups.as': `As`,
  'dashboard.shared.groups.searchPlaceholder': `Search for a group...`,
  'dashboard.shared.groups.noGroupFound': `No group found.`,

  'program.noProgramModal.title': `You don't have a mentoring program yet.`,
  'program.noProgramModal.body': `If you think this should be the case or for any questions, please contact us via support.`,
  'program.noProgramModal.viewProfil': `View my profile`,

  // Admin Program settings
  'admin.programSettings.newProgram': 'Create a new program',
  'admin.programSettings.title': 'Program settings',
  'admin.programSettings.section.general': 'General',
  'admin.programSettings.programType.title': `Program goal (Constel team)`,
  'admin.programSettings.programType.hint': `Visible to and editable by the Constel team only. It decides what the client's dashboard measures.`,
  'admin.programSettings.programType.label': `Program type`,
  'admin.programSettings.programType.save': `Save the goal`,
  'admin.programSettings.programType.saved': `Program goal saved`,
  'admin.programSettings.programType.option.UNDECLARED': `Not declared`,
  'admin.programSettings.programType.option.MATCHING': `Matching`,
  'admin.programSettings.programType.option.SESSIONS': `Session track`,
  'admin.programSettings.programType.option.CURRICULUM': `Graded curriculum`,
  'admin.programSettings.programType.option.ON_DEMAND': `On demand`,
  'admin.programSettings.programType.description.UNDECLARED': `The dashboard infers the type from the program name, otherwise it shows "goal to declare".`,
  'admin.programSettings.programType.description.MATCHING': `The program delivers a pair that talks: we measure mentees in touch with their mentor within a month of being matched, and requests served within 30 days.`,
  'admin.programSettings.programType.description.SESSIONS': `Each pair holds the planned number of sessions: we measure the start at 45 days, continuity and pace against the target.`,
  'admin.programSettings.programType.description.CURRICULUM': `Sessions are set by a curriculum and graded: we measure mentees graded on every session.`,
  'admin.programSettings.programType.description.ON_DEMAND': `Occasional consultations with no planned pace: we follow those seen within 90 days, with no colour.`,
  'admin.programSettings.section.chat': 'Chat',
  'admin.programSettings.section.chatModeration': 'Chat moderation',
  'admin.programSettings.section.groups': 'Group composition',
  'admin.programSettings.section.matching': 'Matching',
  'admin.programSettings.section.session': 'Session',
  'admin.programSettings.section.branding': 'Branding & Appearance',
  'admin.programSettings.section.branding.description': 'These settings override platform settings for this program',
  'admin.programSettings.form.logo.label': 'Main logo',
  'admin.programSettings.form.logo.placeholder': 'https://example.com/logo.png',
  'admin.programSettings.form.logoSmall.label': 'Compact logo',
  'admin.programSettings.form.logoSmall.placeholder': 'https://example.com/logo-small.png',
  'admin.programSettings.form.favicon.label': 'Favicon',
  'admin.programSettings.form.favicon.placeholder': 'https://example.com/favicon.ico',
  'admin.programSettings.form.colorPrimary.label': 'Primary color',
  'admin.programSettings.form.colorPrimary.placeholder': '#000000',
  'admin.programSettings.form.colorSecondary.label': 'Secondary color',
  'admin.programSettings.form.colorSecondary.placeholder': '#ffffff',
  'admin.programSettings.form.name.label': 'Program name',
  'admin.programSettings.form.name.placeholder': 'Program name',
  'admin.programSettings.form.description.label': 'Program description',
  'admin.programSettings.form.description.placeholder': 'Program description',
  'admin.programSettings.form.mentorName.label': 'Custom mentor name',
  'admin.programSettings.form.mentorName.placeholder': 'Custom mentor name',
  'admin.programSettings.form.menteeName.label': 'Custom mentee name',
  'admin.programSettings.form.menteeName.placeholder': 'Custom mentee name',
  'admin.programSettings.form.dashboardType.label': 'Dashboard type',
  'admin.programSettings.form.dashboardType.matching': 'Follow matching',
  'admin.programSettings.form.dashboardType.feedback': 'Follow feedback',
  'admin.programSettings.form.programPeriod.label': 'Program period:',
  'admin.programSettings.form.programPeriod.start.label': 'Start',
  'admin.programSettings.form.programPeriod.start.placeholder': 'Start',
  'admin.programSettings.form.programPeriod.end.label': 'End',
  'admin.programSettings.form.programPeriod.end.placeholder': 'End',
  'admin.programSettings.form.defaultInactivityDays.label':
    "Delay before sending inactivity email based on the user's last message (in days)",
  'admin.programSettings.form.defaultInactivityDays.placeholder': 'Number of days',
  'admin.programSettings.form.contactWarningEnabled.label':
    'Warn the user when sharing personal contact information (email, phone, social networks, etc.)',
  'admin.programSettings.form.maxUserPerGroup.label': 'Maximum number of mentors and mentees per group',
  'admin.programSettings.form.maxGroupPerMentor.label': 'Maximum number of groups per mentor',
  'admin.programSettings.form.maxGroupPerMentee.label': 'Maximum number of groups per mentee',
  'admin.programSettings.form.max.placeholder': 'Maximum number',
  'admin.programSettings.form.matchingCriteriaEnabled.label': 'Enable matching criteria',
  'admin.programSettings.form.matchingAutoSuggestEnabled.label': 'Allow automatic matching',
  'admin.programSettings.form.matchingAdditionalInstructions.label': 'Additional instructions',
  'admin.programSettings.form.matchingAdditionalInstructions.placeholder': 'Additional instructions...',
  'admin.programSettings.form.mentorMatchingCriteria.label': 'Mentor matching criteria',
  'admin.programSettings.form.mentorMatchingCriteria.placeholder': 'Example: I like math, music etc.',
  'admin.programSettings.form.menteeMatchingCriteria.label': 'Mentee matching criteria',
  'admin.programSettings.form.menteeMatchingCriteria.placeholder': 'Example: I like math, music etc.',
  'admin.programSettings.form.menteeCanBookSession.label': 'The mentee can book a session',
  'admin.programSettings.form.shouldReviewSessionRating.label': 'Session rating',
  'admin.programSettings.form.shouldReviewSessionReview.label': 'Session review',
  'admin.programSettings.form.shouldMentorReviewSessionPresence.label': 'Mentee presence',
  'admin.programSettings.form.shouldReviewSessionDeliverable.label': 'Session deliverable',
  'admin.programSettings.form.shouldMentorReviewSessionDeliverableRate.label':
    'Score out of 20 for session deliverable',
  'admin.programSettings.form.shouldMentorReviewSessionDeliverableReport.label': 'End of session report (mentor)',
  'admin.programSettings.form.mentorReportTemplate.label': 'Session report template',
  'admin.programSettings.form.mentorReportTemplate.placeholder': 'Session report template...',
  'admin.programSettings.form.shouldMenteeReviewSessionReport.label': 'End of session report (mentee)',
  'admin.programSettings.form.menteeReportTemplate.label': 'Session report template (mentee)',
  'admin.programSettings.form.menteeReportTemplate.placeholder': 'Session report template...',
  'admin.programSettings.toast.updateSuccess': 'Saved successfully',
  'admin.programSettings.toast.createError': 'Error while creating program',

  // Sessions
  'session.addToCalendarModal.title': `Add to<br/>my calendar 📆`,
  'session.addToCalendarModal.bodyInformation': `Make sure you don't miss your mentoring session by adding this event to your preferred calendar.`,
  'session.listing.empty': `You don't have any sessions yet.`,
  'session.reviewModal.addDeliverableModal.title': `Documents expected<br/>by your %*mentor*%? 🤔`,
  'session.reviewModal.addDeliverableModal.body': `Add documents to this session to share them with your %*mentor*%.`,
  'session.reviewModal.addDeliverableModal.sending': `Sending...`,
  'sesion.reviewModal.addDeliverableModal.received': `Received`,
  'session.reviewModal.addDeliverableModal.sendLater': `Send later`,
  'session.reviewModal.addDeliverableModal.next': `Next`,
  'session.reviewModal.addDeliverableModal.fileDeleted': `File deleted.`,
  'session.reviewModal.addDeliverableModal.noDeliverableCheckbox': `I don't want to submit a deliverable for this session`,
  'session.deliverable.sentAt': `Sent on`,
  'session.deliverable.noDeliverable': `No document submitted.`,
  'session.deliverables.modifyRating': `Modify ratings`,
  'session.deliverable.downloadInProgress': `Download in progress...`,
  'session.deliverable.downloading': `Downloading...`,
  'session.deliverable.downloadStarted': `Download started`,
  'session.deliverable.downloadMayTakeTime': `Download may take time depending on file size...`,
  'session.deliverable.downloadComplete': `Download complete!`,
  'session.newSessionModal.title': `Schedule a new session`,
  'session.newSessionModal.modifySession.title': `Modify the session ✏️`,
  'session.newSessionModal.generalInformation.input.group.label': `Group`,
  'session.newSessionModal.generalInformation.input.name.label': `Session name`,
  'session.newSessionModal.generalInformation.input.name.placeholder': `Enter a name for this session`,
  'session.newSessionModal.generalInformation.input.date.label': `Date`,
  'session.newSessionModal.generalInformation.input.date.placeholder': `12-03-2024`,
  'session.newSessionModal.generalInformation.input.type.label': `Session type`,
  'session.newSessionModal.generalInformation.input.location.label': `Location`,
  'session.newSessionModal.generalInformation.input.location.placeholder': `At the university, in the company premises, etc.`,
  'session.newSessionModal.locationDisabledPlaceholder': `No location needed for a remote session`,
  'session.newSessionModal.endsAt': `Ends at {time}`,
  'session.newSessionModal.generalInformation.input.schedule.label': `Time`,
  'session.newSessionModal.generalInformation.input.schedule.placeholder': `09:00`,
  'session.newSessionModal.generalInformation.input.duration.label': `Duration`,
  'session.newSessionModal.generalInformation.input.objective.label': `Session objective`,
  'session.newSessionModal.generalInformation.input.objective.none': `No objective`,
  'session.newSessionModal.plan': `Schedule the session`,
  'session.newSessionModal.modify': `Confirm changes`,
  'session.newSessionModal.success.create': `Your session has been successfully created`,
  'session.newSessionModal.success.update': `Your session has been successfully updated`,
  'session.newSessionModal.error.update': `An error occurred while updating the session`,
  'session.newSessionModal.error.overlap': `The session overlaps another session`,
  'session.newSessionModal.validation.date.required': `Date is required`,
  'session.newSessionModal.validation.type.required': `Type is required`,
  'session.newSessionModal.validation.schedule.required': `Time is required`,
  'session.newSessionModal.validation.schedule.invalid': `Invalid time, for example 14:30`,
  'session.newSessionModal.validation.duration.required': `Duration is required`,
  'session.newSessionModal.validation.group.required': `Group is required`,
  'session.newSessionModal.validation.location.requiredIfInPerson': `Location is required when the type is in-person`,
  'session.newSessionModal.validation.formIncomplete': `Please fill in all required fields`,
  'session.deliverablesRatingModal.title': `It's time<br/>to rate your %*mentee*%s! 🎓`,
  'session.deliverablesRatingModal.body': `Rate your students' work if a deliverable was expected during this session.`,
  'session.deliverablesRatingModal.whatNoteDoYouGive': `What grade do you give {name}?`,
  'session.deliverablesRatingModal.sentAt': `Sent on {date}`,
  'session.deliverablesRatingModal.noMentees': `No %*mentee*%s were present during this session.<br />You can continue to the next step.`,
  'session.deliverablesRatingModal.success': `Your grades have been successfully recorded!`,
  'session.deliverablesRatingModal.invalidRate': `A grade must be between 0 and 20.`,
  'session.finishedReview.title': `The session has been completed<br/>successfully! 🎉`,
  'session.finishedReview.body.part1': `Thank you very much for your involvement!`,
  'session.finishedReview.body.part2': `Thanks to you, this mentoring session is a real success. Your detailed assessment and valuable feedback will greatly help us improve the experience of this program!`,
  'session.finishedReview.success': `Your feedback has been successfully recorded!`,
  'session.presencesModal.title': `Validate attendances<br/>for the session 📝`,
  'session.presencesModal.body': `Indicate who was present or absent during this session.`,
  'session.presencesModal.presenceFor': `Attendance of {name}`,
  'session.presencesModal.success': `Attendances have been successfully recorded!`,
  'session.rateSessionModal.title': `How was the session?<br/>Tell us more! 💪`,
  'session.rateSessionModal.body': `How did the session go?`,
  'session.rateSessionModal.success': `Your feedback has been successfully recorded!`,
  'session.rateSessionModal.infoMentorNoAccess': `Your %*mentor*% doesn't have access to this review.`,
  'session.rateSessionModal.infoMenteesNoAccess': `Your %*mentee*%s don't have access to this review.`,
  'session.rateSessionModal.input.review.label': `Review`,
  'session.rateSessionModal.input.review.placeholder': `The session went very well, etc.`,
  'session.reportModal.title': `We finish<br/>with a small report! 📝`,
  'session.reportModal.body': `Take a few minutes to write your report!<br/><br/>This is the opportunity to provide valuable feedback to your %*mentee*%s: improvement axes, key points of the session, or evaluation of deliverables. Each detail counts to help them progress.`,
  'session.reportModal.input.report.label': `Report`,
  'session.reportModal.input.report.placeholder': `Main topics covered, Objectives, Conclusions...`,
  'session.reportModal.success': `Your report has been successfully recorded!`,
  'session.reportModal.modifyReport.report': `Modify my report`,
  'session.menteeReportModal.title': `Share your<br/>feedback! 📝`,
  'session.menteeReportModal.body': `Take a moment to write your session report...`,
  'session.menteeReportModal.input.report.label': `Your report`,
  'session.menteeReportModal.success': `Your report has been successfully recorded!`,
  'session.menteeReportModal.modifyReport': `Modify report`,
  'session.pendingActions.menteeReport.title': `Write a report`,
  'session.pendingActions.menteeReport.label': `Report`,
  'session.menteeReport.title': `%*mentee*% report`,
  'session.menteeReport.author': `Written by`,
  'session.menteeReport.empty': `No report has been written.`,
  'session.menteeReport.modified': `Modified at`,
  'session.deliverables.title': `%*mentee*% grades and submissions`,
  'session.deliverables.averageOfGrades': `Average of grades:`,
  'session.deliverables.notGraded': `Not graded`,
  'session.deliverables.noGradeAndDeliverable': `No grade or submission.`,
  'session.deliverables.noDeliverable': `No deliverable.`,
  'session.ownDeliverables.title': `My deliverables`,
  'session.ownDeliverables.modifyDeliverables': `Modify my deliverables`,
  'session.generalInformations.title': `General information`,
  'session.type.online': `Online`,
  'session.type.irl': `In-person`,
  'session.participants.title': `Session status by participant`,
  'session.pendingActions.title': `Pending actions`,
  'session.pendingActions.finishedActions': `Completed<br/>actions`,
  'session.pendingActions.completeSession': `Complete the session`,
  'session.pendingActions.review.title': `Leave a review`,
  'session.pendingActions.review.label': `Review`,
  'session.pendingActions.presences.title': `Validate attendance(s)`,
  'session.pendingActions.presences.label': `Attendance(s)`,
  'session.pendingActions.deliverables.label': `Grade`,
  'session.pendingActions.deliverables.title': `Grade the %*mentee*%(s)`,
  'session.pendingActions.sendDeliverable.title': `Send a deliverable`,
  'session.pendingActions.sendDeliverable.label': `Deliverable(s)`,
  'session.pendingActions.report.title': `Write a report`,
  'session.pendingActions.report.label': `Report`,
  'session.pendingActions.finished.title': `Session completed 🎉`,
  'session.pendingActions.finished.label': `Completed!`,
  'session.presences.title': `Attendances`,
  'session.presences.noPresences': `No attendances recorded.`,
  'session.report.title': `%*mentor*% report`,
  'session.report.empty': `No report has been written.`,
  'session.report.modified': `Modified at`,
  'session.review.title': `Reviews`,
  'session.review.averageOfRates': `Average of ratings:`,
  'session.review.noRate': `No rating.`,
  'session.review.noReview': `No review.`,
  'session.cancel.confirmation.title': `Are you sure you want to cancel this session?`,
  'session.cancel.success': `The session has been successfully canceled!`,
  'session.decline.success': `The session has been successfully declined!`,
  'session.accept.success': `The session has been successfully accepted!`,
  'session.addToCalendar.session.title': `Add to my calendar`,
  'session.addToCalendar.event.title': `Mentoring session`,
  'session.status.all': 'All',
  'session.status.planned': 'Planned',
  'session.status.waitConfirmation': 'Awaiting confirmation',
  'session.status.waitReviews': 'To be completed',
  'session.status.ongoing': 'To be completed by %*mentor*%/%*mentee*%',
  'session.status.none': 'No status',
  'session.status.finished': 'Finished',
  'session.status.cancelled': 'Cancelled',
  'session.status.admin.all': 'All',
  'session.status.admin.planned': 'Planned',
  'session.status.admin.ongoing': 'To be completed by %*mentor*%/%*mentee*%',
  'session.status.admin.finished': 'Finished',
  'session.status.admin.cancelled': 'Cancelled',
  'session.status.user.present': 'Present',
  'session.status.user.absent': 'Absent',
  'session.status.user.waitConfirmation': `Awaiting confirmation`,
  'session.status.user.waitReviews': `Not completed`,
  'session.status.user.planned': `Participate`,
  'session.status.user.finished': `Completed`,
  'session.status.user.cancelled': `Cancelled`,
  'session.status.grade.rated': 'Rated',
  'session.status.grade.toFill': 'To be filled',

  // Chat
  'chat.conversationsList.empty': `You don't have any conversations yet.`,
  'chat.conversationsList.select': 'Start by selecting a conversation.',
  'chat.conversationsList.unread': 'New messages',
  'chat.conversationsList.searchPlaceholder': `Search conversations`,
  'chat.conversationsList.filterLabel': `Filter conversations`,
  'chat.conversationsList.filter.all': `All`,
  'chat.conversationsList.filter.unread': `Unread`,
  'chat.conversationsList.noResult': `No matching conversation.`,
  'chat.conversationsList.you': `You:`,
  'chat.conversationsList.unreadCount': `{count} unread message(s)`,
  'chat.conversationsList.sessionRequest': `Session request`,
  'chat.conversationsList.attachment': `Attachment`,
  'chat.conversationsList.yesterday': `yesterday`,
  'chat.conversation.noMessagesSentYetInGroup': `You haven't exchanged messages with your mentoring group yet. Send a first message to introduce yourself.`,
  'chat.conversation.generatingAIMessage': 'Generating your message...',
  'chat.conversation.placeholder.message': `Write a message...`,
  'chat.conversation.attachFile': `Attach a file`,
  'chat.conversation.removeFile': `Remove {name}`,
  'chat.conversation.today': `Today`,
  'chat.conversation.yesterday': `Yesterday`,
  'chat.empty.title': `Start the conversation`,
  'chat.empty.introduce': `Introduce myself`,
  'chat.privacyNotice.text': `Follow the programme guidelines and avoid sharing sensitive personal information.`,
  'chat.privacyNotice.dismiss': `Dismiss this reminder`,
  'chat.programmeEnded.text': `This programme ended on {date}. You can still message each other here.`,
  'chat.header.yourRole': `Your role:`,
  'chat.header.sessionsProgress': `Session {done} of {expected}`,
  'chat.header.sessionsCount': `{count} session(s) held`,
  'chat.context.label': `Mentoring context`,
  'chat.context.open': `Show pair context`,
  'chat.messageSearch.open': `Search in conversation`,
  'chat.messageSearch.placeholder': `Search messages`,
  'chat.messageSearch.count': `{current} of {total}`,
  'chat.messageSearch.noResult': `No results`,
  'chat.messageSearch.older': `Previous result`,
  'chat.messageSearch.newer': `Next result`,
  'chat.messageSearch.close': `Close search`,
  'chat.attachments.label': `Attached files`,
  'chat.attachments.countOne': `1 attached file`,
  'chat.attachments.countOther': `{count} attached files`,
  'chat.attachments.uploading': `{count} uploading`,
  'chat.attachments.failed': `{count} failed`,
  'chat.attachments.ready': `Ready`,
  'chat.attachments.failedFile': `Upload failed`,
  'chat.attachments.retry': `Retry uploading {name}`,
  'chat.attachments.uploadingFile': `Uploading {name}`,
  'chat.attachments.show': `Show attached files`,
  'chat.attachments.hide': `Hide attached files`,
  'chat.context.nextSession': `Next session`,
  'chat.context.noSession': `No session planned yet.`,
  'chat.context.progress': `Progress`,
  'chat.context.sessionsDone': `Sessions held: {done} of {expected}`,
  'chat.context.objectives': `Objectives`,
  'chat.context.objective.done': `completed`,
  'chat.context.objective.current': `in progress`,
  'chat.context.objective.todo': `upcoming`,
  'chat.context.documents': `Shared documents`,
  'chat.context.documentsAll': `See all {count} documents`,
  'chat.context.moreImages': `See all {count} images`,
  'chat.documents.searchPlaceholder': `Search documents`,
  'chat.documents.filterLabel': `Document type`,
  'chat.documents.filter.all': `All`,
  'chat.documents.filter.images': `Images`,
  'chat.documents.filter.files': `Files`,
  'chat.documents.open': `Open {name}`,
  'chat.documents.download': `Download {name}`,
  'chat.conversationsList.title': `Messages`,
  'chat.conversationsList.noMessageYet': `No messages yet`,
  'chat.newConversation.open': `New conversation`,
  'chat.newConversation.title': `New conversation`,
  'chat.newConversation.description': `Pick someone from your groups to write to.`,
  'chat.newConversation.searchPlaceholder': `Search for someone`,
  'chat.newConversation.heading': `People from your groups`,
  'chat.newConversation.empty': `No one found.`,
  'chat.session.loading': `Loading the session`,
  'chat.session.today': `Today, {time}`,
  'chat.session.metaOnline': `{duration} · video call`,
  'chat.session.metaPlace': `{duration} · {place}`,
  'chat.session.duration.minutes': `{count} min`,
  'chat.session.duration.hours': `{hours} h`,
  'chat.session.duration.hoursMinutes': `{hours} h {minutes} min`,
  'chat.session.status.toConfirm': `To confirm`,
  'chat.session.status.planned': `Planned`,
  'chat.session.status.ongoing': `In progress`,
  'chat.session.status.toComplete': `To complete`,
  'chat.session.status.waitReviews': `Awaiting feedback`,
  'chat.session.status.finished': `Completed`,
  'chat.session.status.cancelled': `Cancelled`,
  'chat.session.waitingFor': `Waiting for {names}`,
  'chat.session.startsIn': `Starts in {count} min`,
  'chat.session.startsInHours': `Starts in {count} h`,
  'chat.session.endsAt': `Ends at {time}`,
  'chat.session.reportExpected': `Your report is expected`,
  'chat.session.cancelledOn': `Cancelled on {date}`,
  'chat.session.edit': `Edit the proposal`,
  'chat.session.join': `Join the session`,
  'chat.session.addToCalendar': `Add to my calendar`,
  'chat.session.writeReport': `Write the report`,
  'chat.session.viewReport': `View the report`,
  'chat.files.open': `Open {name}`,
  'chat.files.download': `Download {name}`,
  'chat.documents.noResult': `No document matches “{query}”`,
  'chat.documents.noResultHint': `Search looks at file names and at the name of the person who shared them.`,
  'chat.documents.clearSearch': `Clear search`,
  'chat.documents.none': `No document of this type.`,
  'chat.conversation.error.messageTooLong': `Your message exceeds the 5000 character limit.`,
  'chat.conversation.noUsersFound': `No users found.`,
  'chat.conversation.error.fileTooLarge': `File is too large. Maximum size: {maxSize}`,
  'chat.conversation.session.request': `A session has been requested.`,
  'chat.conversation.session.declined': `You have declined the session.`,
  'chat.conversation.session.accepted': `You have accepted the session.`,
  'chat.conversation.session.addToCalendar': `Add to my calendar`,
  'chat.conversation.session.place': `Location`,
  'chat.conversation.session.objective': `Objective {number}`,
  'chat.conversation.seenBy': `Seen by`,
  'chat.conversation.uploading': `Uploading`,
  'chat.conversation.uploaded': `Uploaded`,
  'chat.conversation.fileDeleted': `File deleted`,
  'chat.contactWarningModal.title': `⚠️ Contact information detected`,
  'chat.contactWarningModal.body.intro': `To ensure an optimal experience, we recommend that you continue to communicate directly through the platform's chat.`,
  'chat.contactWarningModal.body.benefit1': `✔️ You benefit from a <b>centralized history</b>, accessible at any time`,
  'chat.contactWarningModal.body.benefit2': `✔️ Your <b>exchanges are protected</b> against misunderstandings or abuse`,
  'chat.contactWarningModal.body.warning': `Exchanging contact information outside of the chat may result in a loss of protection and important information.`,
  'chat.contactWarningModal.button.send': `Send anyway`,
  'chat.contactWarningModal.button.cancel': `Cancel`,

  // meeting
  'meeting.actions.left': 'You have left the session.',

  // Users
  'user.profile.title': `Settings`,
  'user.profile.subtitle': `Manage your account settings and set email preferences.`,
  'user.profile.nav.profile': `Profile`,
  'user.profile.nav.programs': `Programs`,
  'user.profile.programs.title': `My programs`,
  'user.profile.programs.subtitle': `Manage the settings for each program you participate in.`,
  'user.profile.programs.show': `View`,
  'user.profile.programs.showCriteria': `Show criteria`,
  'user.profile.programs.hideCriteria': `Hide`,
  'user.profile.nav.password': `Authentication`,
  'user.profile.name': `Name`,
  'user.profile.bio': `Bio`,
  'user.profile.uploadImage': `Upload image`,
  'user.profile.description': `Description:`,
  'user.profile.description.empty': `No description has been provided.`,
  'user.profile.sharedNotes.title': `Internal notes on the user`,
  'user.profile.sharedNotes': `This field is only visible to administrators and managers.`,
  'user.profile.sharedNotes.add.placeholder': `[DD/MM/YY] Name: Enter your note here...`,
  'user.profile.sharedNotes.saveChanges': `Save changes`,
  'user.profile.sharedNotes.success': `The notes have been successfully saved!`,
  'user.profile.edit': `Edit my profile`,
  'user.profile.sendMessage': `Send a message`,
  'user.profile.preferences': `Preferences`,
  'user.profile.credentials': `Credentials`,
  'user.profile.language.appLanguage': `Application language`,
  'user.profile.matchingCriteria': `Matching criteria:`,
  'user.profile.mentorMatchingCriteria': `Matching criteria (%*mentor*%):`,
  'user.profile.menteeMatchingCriteria': `Matching criteria (%*mentee*%):`,
  'user.profile.matchingCriterias.title': `Matching criteria`,
  'user.profile.matchingCriterias.criteriaLabel': `{role} criteria`,
  'user.profile.matchingCriterias.mentorSection': `%*mentor*%`,
  'user.profile.matchingCriterias.menteeSection': `%*mentee*%`,
  'user.profile.matchingCriterias.empty': `Not filled in`,
  'user.info.copyEmail': `Copy email address`,
  'user.info.copyEmail.success': `Address copied!`,

  // Dashboard
  'dashboard.greeting': `Hello {name}`,
  'dashboard.subtitle': `View your sessions, progress and next steps.`,
  'dashboard.shared.programProgress.title': `Program progress`,
  'dashboard.shared.programProgress.viewProgram': `View program objective`,
  'dashboard.shared.programProgress.viewProgramModal': `Program objective`,
  'dashboard.shared.programProgress.programBadge': `Program`,
  'dashboard.shared.programProgress.doneSessions': `Completed session(s)`,
  'dashboard.shared.programProgress.pendingActions': `Pending action(s)`,
  'dashboard.shared.plannedSessions.title': `Planned session(s)`,
  'dashboard.shared.plannedSessions.noSession': `No planned sessions.`,
  'dashboard.mentor.mentees.title': `Your %*mentee*%s`,
  'dashboard.mentor.mentees.noMentee': `You don't have any %*mentee*%(s) for this program yet.`,
  'dashboard.shared.programProgress.members': `Members`,
  'dashboard.shared.programProgress.mentor': `Mentor`,
  'dashboard.shared.programProgress.mentee': `Mentee`,
  'dashboard.shared.programProgress.me': `Me`,
  'dashboard.shared.programProgress.groupSettings': `Group settings`,
  'dashboard.shared.programObjectives.title': `Program sessions`,
  'dashboard.shared.programObjectives.noObjectives': `No session defined for this program.`,
  'dashboard.shared.programObjectives.noGroups': `You don't have a group in this program yet.`,
  'dashboard.shared.programObjectives.objectiveNumber': `Objective {number}`,
  'dashboard.shared.programObjectives.progress': `{completed} session(s) planned out of {expected}`,
  'dashboard.shared.programObjectives.readBeforeSession': `Read before starting the session`,
  'dashboard.shared.programObjectives.planSession': `Add a session`,
  'dashboard.shared.programObjectives.chatWithGroup': `Chat with my group`,
  'dashboard.shared.programObjectives.createNewSession': `Create a new session`,
  'dashboard.shared.programObjectives.linkExistingSession': `Link an existing session`,
  'dashboard.shared.programObjectives.notPlanned': `Not planned`,
  'dashboard.shared.programObjectives.learnMore': `Learn more`,
  'dashboard.shared.programObjectives.cardTitle': `{name} pathway`,
  'dashboard.shared.programObjectives.viewMore': `View more`,
  'dashboard.shared.programObjectives.exchange': `Chat`,
  'dashboard.shared.programObjectives.schedule': `Schedule`,
  'dashboard.shared.programObjectives.sessionLabel': `{name}, on {date}`,
  'dashboard.shared.lockedContent.noGroup': `This section will be unlocked when you have a mentoring group`,
  'dashboard.shared.waitingAlert.title': `Your matching is in progress`,
  'dashboard.shared.waitingAlert.description': `You will receive an email as soon as you are matched. In the meantime, consider completing your profile if you haven't already.`,

  // Profile completion
  'profileCompletion.title': `Profile completed at`,
  'profileCompletion.profileLevel': `Profile level: {level}`,
  'profileCompletion.levels.beginner': `Beginner`,
  'profileCompletion.levels.basic': `Basic`,
  'profileCompletion.levels.intermediate': `Intermediate`,
  'profileCompletion.levels.advanced': `Advanced`,
  'profileCompletion.levels.expert': `Expert`,
  'profileCompletion.description': `A little more effort to optimize your mentoring opportunities.`,
  'profileCompletion.nextStep': `Next step`,
  'profileCompletion.steps.mentorCriteria': `Fill in your matching criteria for this program`,
  'profileCompletion.steps.menteeCriteria': `Fill in your matching criteria for this program`,
  'profileCompletion.steps.findMentor': `Find a mentor`,
  'profileCompletion.steps.description': `Complete your profile description`,
  'profileCompletion.steps.picture': `Add a profile picture`,
  'profileCompletion.buttons.fillCriteria': `Fill in`,
  'profileCompletion.buttons.findMentor': `Find`,
  'profileCompletion.buttons.addDescription': `Complete`,
  'profileCompletion.buttons.addPicture': `Add`,
  'profileCompletion.steps.phone': `Add your phone number`,
  'profileCompletion.buttons.addPhone': `Add`,

  // Session objectives link modal
  'sessionObjectives.linkSessionModal.title': `Link a session to the objective`,
  'sessionObjectives.linkSessionModal.loading': `Loading sessions...`,
  'sessionObjectives.linkSessionModal.error': `Error loading sessions`,
  'sessionObjectives.linkSessionModal.noSessions': `No sessions available in this group`,
  'sessionObjectives.linkSessionModal.selectLabel': `Select a session`,
  'sessionObjectives.linkSessionModal.linkButton': `Link session`,
  'sessionObjectives.linkSessionModal.cancelButton': `Cancel`,
  'sessionObjectives.linkSessionModal.success': `Session successfully linked to the objective`,

  // redirect
  'redirect.loading': `Redirecting...`,
  'redirect.notification.interface': `Switch rights on your new selected program, redirecting...`,

  // auth

  'auth.login.title': `Login to your space <strong>{appTitle}</strong>`,
  'auth.login.classicLogin': `Login with email and password`,
  'auth.login.login': `Login`,
  'auth.login.error': 'Incorrect username or password',
  'auth.login.email.errors.invalid': 'The email is invalid',
  'auth.login.email.placeholder': `Enter your email`,
  'auth.login.password.errors.invalid': 'The password is invalid',
  'auth.login.checkingSSOUser': `Checking your account...`,
  'auth.login.forgotPassword': `Forgot your password or first time here?`,
  'auth.login.or': 'Or continue with',
  'auth.login.continueWith': 'Continue with {companyName}',
  'auth.login.continue': `Continue`,
  'auth.login.changeEmail': `Change`,
  'auth.login.changeEmailAriaLabel': `Change email address`,
  'auth.login.signedInAs': `Signing in as`,
  'auth.login.unknownEmail.title': `No account for this address`,
  'auth.login.unknownEmail.body': `Check the address you entered. You may have an account under another address, personal or professional. If you cannot find it, contact support.`,
  'auth.forgotPassword.title': `Forgot your password?`,
  'auth.forgotPassword.body': `A code will be sent to your email to help reset password`,
  'auth.forgotPassword.backToLogin': `Back to login`,
  'auth.forgotPassword.contactSupport.text': `Didn't receive the email? Contact us at`,
  'auth.forgotPassword.sendEmail': `Recover my password`,
  'auth.forgotPassword.error.userNotFound': `The email is not registered in our database. Please check your email.`,
  'auth.forgotPassword.error.rateLimitExceeded': `Too many reset requests. Please try again in 1 hour.`,
  'auth.forgotPassword.error.tokenExpired': `This reset link has expired (30 minutes). Please request a new one.`,
  'auth.forgotPassword.error.tokenAlreadyUsed': `This reset link has already been used. Please request a new one if needed.`,
  'auth.forgotPassword.error.tokenInvalid': `This reset link is invalid. Please request a new one.`,
  'auth.forgotPassword.emailSent': `If this email is registered, you will receive an email with the <strong>instructions to reset your password</strong>.`,
  'auth.forgotPassword.emailSentSuccess': `If this email is registered, you will receive an email with the instructions to reset your password.`,
  'auth.forgotPassword.checkEmail.title': `Check your email!`,
  'auth.forgotPassword.checkEmail.body': `If <strong>{email}</strong> is registered, we've sent a password reset link to it, valid for <strong>30 minutes</strong>.`,
  'auth.forgotPassword.checkEmail.intro': `To continue, click on the link sent to`,
  'auth.forgotPassword.checkEmail.resend': `Resend the email`,
  'auth.forgotPassword.resetPassword': `Reset my password`,
  'auth.forgotPassword.error.passwordsDoNotMatch': `The passwords do not match.`,
  'invitation.title': `Activate your account`,
  'invitation.subtitle': `Set your password to activate your account on {company}`,
  'invitation.loading': `Verifying your invitation link…`,
  'invitation.email.label': `Email address`,
  'invitation.password.label': `Password`,
  'invitation.confirmPassword.label': `Confirm password`,
  'invitation.cgu.label': `I accept the {cgu} and the {privacy}.`,
  'invitation.cgu.cguLink': `terms and conditions`,
  'invitation.cgu.privacyLink': `privacy policy`,
  'invitation.cgu.errors.required': `You must accept the terms and conditions and the privacy policy.`,
  'invitation.submit': `Activate my account`,
  'invitation.success': `Your account has been activated. Please sign in.`,
  'invitation.errorBackToLogin': `Back to sign in`,
  'invitation.error.invalid': `This invitation link is invalid.`,
  'invitation.error.expired': `This invitation link has expired. Ask an administrator to resend an invitation.`,
  'invitation.error.used': `This invitation link has already been used.`,
  'invitation.error.passwordsDoNotMatch': `The passwords do not match.`,
  'invitation.error.generic': `An error occurred while activating your account.`,
  'auth.forgotPassword.success.passwordReset': `Your password has been successfully reset!`,
  'auth.forgotPassword.success.passwordResetAndLoggedIn': `Your password has been successfully reset! You are now logged in.`,
  'auth.forgotPassword.error.generic': `An error occurred while resetting your password.`,
  'auth.saml.error.internalError': `An error occurred during authentication. Please contact support for assistance. Error code: {errorId}`,
  'auth.saml.error.authFailed': `An error occurred during authentication. Please contact support for assistance. Error code: {errorId}`,
  'auth.saml.error.signatureError': `SAML signature validation error. Please check certificate configuration or contact support. Code: {errorId}`,
  'auth.saml.error.userNotRegistered': `You do not have access to the platform yet. Please contact support to request access.`,
  'auth.password.errors.required': `Password is required`,
  'auth.password.errors.minLength': `Password must be at least 8 characters long`,
  'auth.password.errors.lowercase': `Password must contain at least one lowercase letter`,
  'auth.password.errors.uppercase': `Password must contain at least one uppercase letter`,
  'auth.password.errors.number': `Password must contain at least one number`,
  'auth.password.errors.specialChar': `Password must contain at least one special character ({'@'}$!%*?&-_#)`,
  'auth.password.errors.mismatch': `Passwords do not match`,
  'auth.password.modify.title': `Change my password 🔒`,
  'auth.password.modify.currentPassword': `Current password`,
  'auth.password.modify.newPassword': `New password`,
  'auth.password.modify.confirmNewPassword': `Confirm new password`,
  'auth.password.modify.success': `Your password has been successfully changed`,
  'user.profile.auth.signInMethods': `Sign in methods`,
  'user.profile.auth.password.configured': `Configured`,
  'user.profile.auth.password.change': `Change password`,
  'user.profile.auth.password.hide': `Hide`,
  'user.profile.auth.password.update': `Update password`,
  'user.profile.auth.twoFactor': `Two-factor authentication`,
  'user.profile.auth.sso.description': `Sign in with your {companyName} account`,
  'user.profile.auth.authenticatorApp': `Authenticator app`,
  'user.profile.auth.twoFactor.description': `Two-factor authentication adds an additional layer of security to your account by requiring more than just a password to sign in.`,
  'auth.mfa.title': `Two-Factor Authentication (MFA)`,
  'auth.mfa.description': `Secure your account with two-factor authentication`,
  'auth.mfa.status.enabled': `Enabled`,
  'auth.mfa.status.disabled': `Disabled`,
  'auth.mfa.button.enable': `Enable`,
  'auth.mfa.button.disable': `Disable`,
  'auth.mfa.setup.title': `Set up Two-Factor Authentication 🔐`,
  'auth.mfa.setup.step1.title': `1. Scan the QR code`,
  'auth.mfa.setup.step1.description': `Use an authenticator app (Google Authenticator, Authy, Microsoft Authenticator) to scan this QR code`,
  'auth.mfa.setup.step1.manualEntry': `Or enter this key manually:`,
  'auth.mfa.setup.step2.title': `2. Backup codes`,
  'auth.mfa.setup.step2.description': `Keep these backup codes in a safe place. They will allow you to log in if you lose access to your authenticator app.`,
  'auth.mfa.setup.step3.title': `3. Verify the code`,
  'auth.mfa.setup.step3.description': `Enter the 6-digit code generated by your app`,
  'auth.mfa.setup.input.code.label': `Verification code`,
  'auth.mfa.setup.input.code.placeholder': `123456`,
  'auth.mfa.setup.success': `Two-factor authentication has been successfully enabled!`,
  'auth.mfa.setup.error': `The verification code is incorrect`,
  'auth.mfa.disable.title': `Disable Two-Factor Authentication ⚠️`,
  'auth.mfa.disable.description': `To disable two-factor authentication, please enter your current password and a verification code`,
  'auth.mfa.disable.input.password.label': `Current password`,
  'auth.mfa.disable.input.password.placeholder': `********`,
  'auth.mfa.disable.input.code.label': `Verification code`,
  'auth.mfa.disable.input.code.placeholder': `123456`,
  'auth.mfa.disable.success': `Two-factor authentication has been disabled`,
  'auth.mfa.disable.error': `The password or verification code is incorrect`,
  'auth.mfa.login.title': `Two-Factor Authentication 🔐`,
  'auth.mfa.login.description': `Enter the 6-digit code generated by your authenticator app`,
  'auth.mfa.login.input.code.label': `Verification code`,
  'auth.mfa.login.input.code.placeholder': `123456`,
  'auth.mfa.login.error': `Invalid verification code`,
  'auth.mfa.login.error.tooManyAttempts': `Too many failed attempts. Please try again in 5 minutes.`,
  'auth.mfa.login.retryIn': `Retry in {time}`,
  'auth.loadingGuard.login': `Logging in...`,
  'auth.loadingGuard.help.title': `Having trouble logging in?`,
  'auth.loadingGuard.help.body': `Contact us`,
  'auth.editProfile.picture.title': `A profile with a photo,<br/>it's always more welcoming! 😊`,
  'auth.editProfile.picture.uploaded': `you look perfect!`,
  'auth.editProfile.picture.conversionError': `This HEIC photo could not be converted. Try another photo, or a .jpg or .png file.`,
  'auth.editProfile.picture.examples.title': 'Examples of good photos',
  'auth.editProfile.picture.examples.body': `A professional photo is required to appear on the platform. Otherwise, your profile might be rejected.`,
  'auth.editProfile.success': `Your profile has been successfully updated!`,
  'auth.editProfile.description.title': `Introduce yourself in a few words 📝`,
  'auth.editProfile.description.placeholder': `I am a ...`,
  'auth.profile.phone': `Phone`,
  'auth.profile.phone.empty': `No phone number provided.`,
  'auth.profile.password': `Password`,
  'auth.phoneModal.title': `Stay informed about <br/> important events! 🤙`,
  'auth.phoneModal.body': `Provide your phone number to be notified of important events in your mentoring program.`,
  'auth.phoneModal.input.label': `Phone number`,
  'auth.phoneModal.input.placeholder': `+33612345678`,
  'auth.phoneModal.doNotAskAgain': `Don't ask me again`,
  'auth.phoneModal.success': `Your phone number has been successfully recorded!`,
  'auth.language.success': `Your language has been successfully updated!`,
  'auth.phoneModal.error.invalid': 'The phone number is invalid',
  'auth.phoneModal.error.startsWith': 'The phone number must start with + (+33 for France)',
  'auth.nameModal.title': `We miss your name! 🫢`,
  'auth.nameModal.body': `Fill in your first name and last name so that the other members of your mentoring group recognize you.`,
  'auth.nameModal.success': `Your name has been successfully recorded!`,

  // General terms
  'user.profile.nav.privacy': `Privacy`,
  'user.profile.privacy.title': `Privacy and legal documents`,
  'user.profile.privacy.subtitle': `Review the documents governing your use of the platform and the processing of your data.`,
  'user.profile.privacy.cgu': `Terms of service`,
  'user.profile.privacy.privacyPolicy': `Privacy policy`,
  'user.profile.privacy.version': `Version of {date}`,
  'user.profile.privacy.view': `View`,
  'user.profile.privacy.acceptedAt': `You accepted them on {date}`,
  'terms.modal.title': `Terms of service and privacy`,
  'terms.modal.bodyInformation': `To use the platform, please accept our terms of service and privacy policy.`,
  'terms.modal.accept': `I accept`,
  'terms.modal.updated': `Our terms of service and privacy policy have been updated. Please accept them again to continue.`,
  'terms.modal.success': `You have accepted the terms of service and privacy policy`,

  // UI Button
  'ui.button.back': 'Back',
  'ui.button.next': 'Next',
  'ui.button.close': 'Close',
  'ui.button.cancel': 'Cancel',
  'ui.button.confirm': 'Confirm',
  'ui.button.save': 'Save',
  'ui.button.delete': 'Delete',
  'ui.button.create': 'Create',
  'ui.button.send': 'Send',
  'ui.button.accept': 'Accept',
  'ui.button.decline': 'Decline',
  'ui.button.change': 'Change',
  'ui.button.continue': 'Continue',
  'ui.button.fillLater': 'Fill in later',
  'ui.button.support': `Contact support`,
  'ui.button.download': `Download`,
  'ui.button.finish': `Finish`,
  'ui.button.show': `Show`,
  'ui.button.filters': `Filters`,
  'ui.button.export': `Export`,
  'ui.button.edit': 'Edit',
  'ui.button.join': 'Join',

  // UI Layout
  'ui.layout.nav.dashboard': 'Dashboard',
  'ui.layout.nav.groups': 'Groups',
  'ui.layout.nav.users': 'Users',
  'ui.layout.nav.sessions': 'Sessions',
  'ui.layout.nav.settings': 'Settings',
  'ui.layout.nav.messages': 'Messages',
  'ui.layout.nav.newSession': 'Schedule a session',
  'ui.layout.nav.support': 'Support',
  'ui.layout.nav.resources': 'Resources',
  'ui.layout.nav.allGroups': 'All groups',
  'ui.layout.nav.ariaLabel': 'Main navigation',
  'ui.layout.skipToContent': 'Skip to main content',

  // Page titles (WCAG 2.4.2) — composed as "Topic – Organisation"
  'ui.pageTitle.login': 'Sign in',
  'ui.pageTitle.forgotPassword': 'Forgotten password',
  'ui.pageTitle.invitation': 'Invitation',
  'ui.pageTitle.cgu': 'Terms of use',
  'ui.pageTitle.privacy': 'Privacy policy',
  'ui.pageTitle.dashboard': 'Dashboard',
  'ui.pageTitle.sessions': 'Sessions',
  'ui.pageTitle.chat': 'Messages',
  'ui.pageTitle.profile': 'Profile',
  'ui.pageTitle.adminDashboard': 'Admin dashboard',
  'ui.pageTitle.adminUsers': 'Users',
  'ui.pageTitle.adminGroups': 'Groups',
  'ui.pageTitle.adminSessions': 'Programme sessions',
  'ui.pageTitle.adminReminders': 'Reminders',
  'ui.pageTitle.adminProgramSettings': 'Programme settings',
  'ui.pageTitle.adminNewProgram': 'New programme',
  'ui.pageTitle.adminSettings': 'My platform',
  'ui.pageTitle.downloadDeliverable': 'Deliverable download',

  'ui.pagination.page': 'Page',
  'ui.pagination.resultsOfOn': 'Results {start} to {end} of {total}',
  'ui.pagination.totalPages': 'Total pages: {total}',
  'ui.filter.status': 'Status',
  'ui.filter.group': 'Group',
  'ui.filter.hasGroup': 'With or without a group',
  'ui.filter.menteesCount': 'Number of mentees',

  // UI Message
  'ui.message.loading': 'Loading...',

  // UI Select
  'ui.select.defaultOption': 'Select an option',
  'ui.select.lang.fr': 'French',
  'ui.select.lang.en': 'English',
  'ui.select.noResults': 'No results found',
  'ui.select.selectAll': 'Select all',

  // UI Input
  'ui.input.label.optional': 'optional',
  'ui.input.placeholder.searchPerson': 'Search by email or name, first name',
  'ui.input.file.instructions.maxSize': 'Max file size:',
  'ui.input.file.instructions.format': 'Accepted formats:',
  'ui.input.file.instructions.minSize': 'Minimum size:',
  'ui.input.file.upload.dragAndDrop': `Drag and drop a file or click here`,
  'ui.input.email.label': 'Email',
  'ui.input.email.placeholder': `john.smith{'@'}example.com`,
  'ui.input.role.label': 'Role(s)',
  'ui.input.firstName.label': 'First name',
  'ui.input.firstName.placeholder': 'John',
  'ui.input.lastName.label': 'Last name',
  'ui.input.lastName.placeholder': 'Smith',
  'ui.input.password.label': 'Password',
  'ui.input.password.placeholder': '••••••••',
  'ui.input.password.show': 'Show password',
  'ui.input.password.hide': 'Hide password',

  // UI Modals
  'ui.modal.confirmation.title': `Are you sure you want to continue?`,
  'ui.modal.confirmation.irreversible': `This action is irreversible.`,

  //UI Informations
  'ui.information.extendable.yes': `...More`,
  'ui.information.extendable.no': `...Less`,

  // More actions
  'moreActions.account.seeProfile': 'View profile',
  'moreActions.account.logout': 'Log out',
  'moreActions.account.switchPlatform.admin': 'Go to admin platform',
  'moreActions.account.switchPlatform.user': 'Go to user platform',
  'moreActions.account.logout.confirmLabel': `Are you sure you want to log out?`,
  'moreActions.session.seeDetails': 'View details',
  'moreActions.session.modify': 'Modify session',
  'moreActions.session.meetingLinkCopy': 'Copy meeting link',
  'moreActions.session.meetingLinkCopy.success': 'Link copied!',
  'moreActions.session.addToCalendar': 'Add to my calendar',
  'moreActions.session.cancel': 'Cancel session',
  'moreActions.session.cancel.confirmLabel': `Are you sure you want to cancel this session?`,
  'moreActions.session.cancel.success': `The session has been successfully cancelled!`,
  'moreActions.user.seeProfile': 'View profile',
  'moreActions.user.sendMessage': 'Send a message',
  'moreActions.user.edit': 'Edit user',
  'moreActions.user.sendInvitation': 'Send invitation link',
  'moreActions.user.sendInvitation.success': 'The invitation link has been sent successfully!',
  'moreActions.user.sendInvitation.sso':
    'No invitation sent: this account signs in with SSO. To let it sign in with a password, use "Switch to e-mail + password".',
  'moreActions.user.switchToPasswordLogin': 'Switch to e-mail + password',
  'moreActions.user.switchToPasswordLogin.confirmTitle': 'Switch this account to e-mail + password?',
  'moreActions.user.switchToPasswordLogin.confirmLabel':
    'This account will no longer sign in with SSO. It will receive an e-mail to choose a password.',
  'moreActions.user.switchToPasswordLogin.success':
    'The account now signs in with e-mail and password. The invitation to choose a password has been sent.',
  'moreActions.user.switchToPasswordLogin.successNoInvitation':
    'The account now signs in with e-mail and password, but the invitation could not be sent. Resend it with "Send invitation link".',
  'moreActions.user.switchToPasswordLogin.alreadyPassword': 'This account already signs in with e-mail and password.',
  'moreActions.user.switchToPasswordLogin.emailLoginDisabled':
    'E-mail and password sign-in is disabled on this platform: only SSO works.',
  'moreActions.user.deleteFromProgram': 'Delete from program',
  'moreActions.user.deleteFromProgram.confirmLabel': `Are you sure you want to delete this user from the program?`,
  'moreActions.user.deleteFromProgram.success': `The user has been successfully deleted from the program!`,
  'moreActions.admin.sessions.CSVExport': 'Export to CSV',
  'moreActions.admin.sessions.XLSXExport': 'Export to XLSX',
  'moreActions.admin.sessions.export.error': `An error occurred during the export.`,
  'moreActions.admin.users.importFromExcel': 'Import from Excel file',
  'moreActions.admin.users.emailInvitation': `Invite by email`,
  'moreActions.system.resetDB.small': 'Reset database (small)',
  'moreActions.system.resetDB.large': 'Reset database (large)',
  'moreActions.system.resetDB.inProgress': 'Reset in progress...',
  'moreActions.system.resetDB.success': 'The database has been successfully reset!',
  'moreActions.admin.groups.modifyStructure': 'Modify structure',
  'moreActions.admin.groups.modifySettings': 'Modify settings',
  'moreActions.admin.groups.delete': 'Delete group',
  'moreActions.admin.groups.delete.confirmLabel': `Are you sure you want to delete this group?`,
  'moreActions.admin.groups.delete.confirmContent': `This action is irreversible.<br/>The data associated with this group will be kept (sessions, reports, notes, etc.).`,

  // widgets
  'widget.nextSession.title': 'Next scheduled session',
  'widget.nextSession.join': 'Join the session',
  'widget.nextSession.name': 'Session',
  'widget.nextSession.inProgress': 'In progress',

  // Common
  'common.mentor': '%*mentor*% | %*mentor*%s',
  'common.mentor.capitalize': `%*mentor*% | %*mentor*%s`,
  'common.mentee': '%*mentee*% | %*mentee*%s',
  'common.mentee.capitalize': `%*mentee*% | %*mentee*%s`,
  'common.manager': 'manager | managers',
  'common.manager.capitalize': `Manager | Managers`,
  'common.admin': 'admin | admins',
  'common.admin.capitalize': `Admin | Admins`,
  'common.support': 'support | supports',
  'common.support.capitalize': `Support | Supports`,
  'common.guest': 'guest | guests',
  'common.guest.capitalize': `Guest | Guests`,
  'common.program': 'program | programs',
  'common.program.capitalize': `Program | Programs`,
  'common.program.select': `Select a program`,
  'common.group': 'group | groups',
  'common.group.capitalize': `Group | Groups`,
  'common.session': 'session | sessions',
  'common.session.capitalize': `Session | Sessions`,

  // fallbacks
  'fallback.mentee': 'mentee',
  'fallback.mentor': 'mentor',

  // Errors
  'error.common': 'An error has occurred',
  'error.userNotFound': 'User not found',
  'error.requiredNameField': 'Name is required',
  'error.requiredEmailField': `Email is required`,
  'error.invalidEmail': `The email is invalid`,
  'error.requiredRoleField': `Role is required`,
  'error.requiredFirstNameField': `First name is required`,
  'error.requiredLastNameField': `Last name is required`,
  'error.upload.tooLarge': `File too large. Maximum size: {maxSize}.`,
  'error.upload.unauthorized': `Your session expired. Sign in again and retry.`,
  'error.upload.serverError': `The storage service is temporarily unavailable. Please retry in a few moments.`,
  'error.upload.network': `Network error during upload. Check your connection and retry.`,
  'error.upload.generic': `File upload failed. Please retry.`,
  'error.upload.aborted': `Upload cancelled.`,

  // Impersonation
  'impersonation.banner.title': 'Impersonation Mode Active',
  'impersonation.banner.description': `You are logged in as {email}`,
  'impersonation.banner.stopButton': 'Return to my account',
  'impersonation.banner.stopping': 'Stopping...',
  'impersonation.banner.confirmStop': 'Are you sure you want to stop impersonating?',
  'impersonation.banner.collapse': 'Collapse banner',
  'impersonation.action.start': 'Log in as this user',
  'impersonation.action.starting': 'Logging in...',
  'impersonation.action.confirm': 'Do you really want to log in as this user?',
  'impersonation.action.success': 'Login successful, redirecting...',
  'impersonation.modal.title': 'User Account Login',
  'impersonation.modal.message': 'Are you sure you want to log in to the account of {email}?',
  'impersonation.modal.reasonLabel': 'Reason for impersonation *',
  'impersonation.modal.selectReason': 'Select a reason',
  'impersonation.modal.customReason': 'Other reason (free text)',
  'impersonation.modal.customReasonLabel': 'Specify the reason',
  'impersonation.modal.customReasonPlaceholder': 'Describe the reason for this login...',
  'impersonation.modal.cancel': 'Cancel',
  'impersonation.modal.confirm': 'Confirm login',
  'impersonation.modal.confirming': 'Logging in...',
  'impersonation.modal.errorRequired': 'Please select or enter a reason',
  'impersonation.reasons.technicalSupport': 'Technical support',
  'impersonation.reasons.bugInvestigation': 'Bug investigation',
  'impersonation.reasons.userAssistance': 'User assistance',
  'impersonation.reasons.dataVerification': 'Data verification',
  'impersonation.reasons.accountIssue': 'Account issue',

  // Error boundary (KC-466)
  'errorBoundary.title': 'Something went wrong',
  'errorBoundary.description': 'Something went wrong on this page. You can go back home to continue.',
  'errorBoundary.goHome': 'Go back home',
  'legal.lastUpdated': `Last updated: {date}`,
  'legal.notConfigured.title': 'Document not yet configured',
  'legal.notConfigured.body':
    'Legal information for this platform has not been filled in yet. Please contact the administrator.',

  // Platform setup (new platform setup wizard)
  'ui.pageTitle.createPlatform': 'Create the platform',
  'admin.setup.created.title': 'The {organization} platform has been created.',
  'admin.setup.created.description': `You are its administrator. Five steps to set it up, about ten minutes: participants see nothing until then.`,
  'admin.setup.create.eyebrow': 'New platform',
  'admin.setup.create.title': 'Your mentoring platform is ready to be created',
  'admin.setup.create.intro': `It has no name, colors or account yet. Start with your organization and your account: you will be its first administrator.`,
  'admin.setup.create.steps.account': 'Your administrator account',
  'admin.setup.create.steps.settings': 'Identity, appearance, sign-in, GDPR',
  'admin.setup.create.steps.program': 'Your first program',
  'admin.setup.create.formTitle': 'Create the platform',
  'admin.setup.create.organization.label': 'Organization name',
  'admin.setup.create.organization.placeholder': 'For example: Horizon School',
  'admin.setup.create.organization.description': 'Your school or company. You can change it later.',
  'admin.setup.create.firstname': 'First name',
  'admin.setup.create.lastname': 'Last name',
  'admin.setup.create.email': 'Your work email',
  'admin.setup.create.password.label': 'Password',
  'admin.setup.create.password.description':
    'At least 8 characters, with an uppercase letter, a lowercase letter, a number and a special character.',
  'admin.setup.create.submit': 'Create the platform',
  'admin.setup.create.note': `This screen only appears once, while the platform has no account. You will then accept the terms of use.`,
  'admin.setup.create.errors.required': 'Fill in the organization name, your first name and your last name.',
  'admin.setup.create.errors.email': 'This email address is not valid.',
  'admin.setup.create.errors.password': 'The password does not meet the rules shown under the field.',
  'admin.setup.create.errors.alreadyCreated': 'This platform has already been created.',
  'admin.setup.create.errors.goToLogin': 'Sign in',
  'admin.setup.create.errors.generic': 'Creation failed. Check your connection, then try again.',
  'admin.platform.edit': 'Edit',
  'admin.platform.cancel': 'Cancel',
  'admin.platform.save': 'Save',
  'admin.platform.forbidden':
    'My platform is reserved for super admins. To change the appearance, sign-in or emails, ask the platform owner to invite you as a super admin.',
  'admin.platform.close': 'Close',
  'admin.platform.sections.team.title': 'Super admins',
  'admin.platform.sections.team.description': 'Access to every programme. They do not appear in user lists.',
  'admin.platform.sections.team.summary.active': '{count} active super admin. | {count} active super admins.',
  'admin.platform.sections.team.summary.pending': '{count} pending invitation. | {count} pending invitations.',
  'admin.platform.sections.team.missing': 'No super admin: invite the people who run the mentoring programme.',
  'admin.platform.sections.team.note':
    'The owner cannot be removed. Anyone removed is notified by email. The Constel team keeps its support access and does not appear here.',
  'admin.platform.sections.team.noteMember':
    '{name} owns the platform: only they can transfer this role. You can neither remove them nor remove yourself.',
  'admin.platform.saved': 'Changes saved',
  'admin.platform.health.ok': 'Everything is in order.',
  'admin.platform.health.todo': '{count} item to complete: | {count} items to complete:',
  'admin.platform.sections.identity.title': 'Identity',
  'admin.platform.sections.identity.description': 'The name of the platform and of your organization',
  'admin.platform.sections.identity.summary': 'The platform is called {title} and belongs to {company}.',
  'admin.platform.sections.identity.missing': 'The platform or organization name is missing.',
  'admin.platform.sections.branding.title': 'Appearance',
  'admin.platform.sections.branding.description':
    'The preview follows every change. Nothing changes for participants until you save.',
  'admin.platform.sections.branding.summary': 'Logo and colors. White text on the primary color: {ratio}:1.',
  'admin.platform.sections.branding.missing': 'No primary color set.',
  'admin.platform.sections.login.title': 'Sign-in',
  'admin.platform.sections.login.description': 'How participants get into the platform',
  'admin.platform.sections.login.summary.both':
    'Participants sign in with your organization SSO or with their email and a password.',
  'admin.platform.sections.login.summary.sso': 'Participants sign in with your organization SSO.',
  'admin.platform.sections.login.summary.email': 'Participants sign in with their email and a password.',
  'admin.platform.sections.login.summary.none': 'No sign-in method is on: nobody can sign in.',
  'admin.platform.sections.support.title': 'Support',
  'admin.platform.sections.support.description': 'Who answers participants when they need help',
  'admin.platform.sections.support.summary': 'When they need help, participants write to {email}.',
  'admin.platform.sections.support.summaryWithPhone':
    'When they need help, participants write to {email} or call {phone}.',
  'admin.platform.sections.support.missing': 'No support contact: participants do not know who to write to.',
  'admin.platform.sections.resources.title': 'Resources',
  'admin.platform.sections.resources.description': `The "Resources" link in participants' menu`,
  'admin.platform.sections.resources.summary': `The "Resources" link in participants' menu leads to`,
  'admin.platform.sections.resources.missing': `No link: the "Resources" entry does not appear in participants' menu.`,
  'admin.platform.sections.emails.title': 'Emails',
  'admin.platform.sections.emails.description': 'The emails the platform sends to your participants',
  'admin.platform.sections.emails.summary.on':
    'The platform sends its automatic emails: invitations, session reminders, notifications.',
  'admin.platform.sections.emails.summary.off': 'Automatic emails are off: only invitations are still sent.',
  'admin.platform.sections.emails.toggle.title': 'Send automatic emails',
  'admin.platform.sections.emails.toggle.description':
    'Session reminders, message notifications, reports, forgotten password. Invitations are always sent.',
  'admin.platform.sections.emails.warning':
    'Once off, participants will receive no reminder or notification, and will no longer be able to reset their password by email. Only invitations will still be sent.',
  'admin.platform.sections.emails.confirm': 'I confirm I want to turn off automatic emails',
  'admin.platform.sections.emails.errors.confirm': 'Tick the confirmation to turn off automatic emails.',
  'admin.platform.sections.emails.soon': 'Coming here soon: customize email content.',
  'admin.platform.sections.legal.title': 'Personal data',
  'admin.platform.sections.legal.description': 'Data controller and DPO, shown in the privacy policy',
  'admin.platform.sections.legal.summary': '{company} is the data controller. Its DPO answers at {dpo}.',
  'admin.platform.sections.legal.missing': 'The data controller or DPO contact is missing from the privacy policy.',
  'admin.platform.sections.legal.privacyLink': 'Read the privacy policy as it is shown',
  'ui.pageTitle.adminSetup': 'Platform setup',
  'ui.layout.nav.platformSettings': 'My platform',
  'admin.setup.loading': 'Loading platform settings...',
  'admin.setup.errors.loading': 'Platform settings could not be loaded. Reload the page.',
  'admin.setup.errors.save': 'Saving failed. Check your connection, then try again.',
  'admin.setup.rail.ariaLabel': 'Setup steps',
  'admin.setup.rail.title': 'Getting started',
  'admin.setup.rail.subtitle': 'Your mentoring platform',
  'admin.setup.rail.autosave': 'Each step is saved when you continue',
  'admin.setup.rail.later': 'Finish later',
  'admin.setup.rail.skipped': 'Skipped, to resume',
  'admin.setup.stepCounter': 'Step {current} of {total}',
  'admin.setup.steps.identity.label': 'Identity',
  'admin.setup.steps.identity.hint': 'Name and organization',
  'admin.setup.steps.branding.label': 'Appearance',
  'admin.setup.steps.branding.hint': 'Logos and colors',
  'admin.setup.steps.login.label': 'Sign-in',
  'admin.setup.steps.login.hint': 'Password or SSO',
  'admin.setup.steps.contact.label': 'Contact and GDPR',
  'admin.setup.steps.contact.hint': 'Support and data controller',
  'admin.setup.steps.recap.label': 'Summary',
  'admin.setup.steps.recap.hint': 'Review and finish',
  'admin.setup.steps.team.label': 'Team',
  'admin.setup.steps.team.hint': 'Super admins',
  'admin.setup.team.title': 'Who runs the platform with you?',
  'admin.setup.team.intro':
    'Invite the people on your team who run the mentoring programme. They become super admins of the platform.',
  'admin.setup.team.invite.label': 'Invite a super admin',
  'admin.setup.team.invite.placeholder': "firstname.lastname{'@'}organisation.com",
  'admin.setup.team.invite.submit': 'Invite',
  'admin.setup.team.invite.description':
    'You can paste several addresses separated by commas. Each person receives an email to create their account.',
  'admin.setup.team.invite.descriptionSso':
    'You can paste several addresses separated by commas. They sign in with your organisation’s SSO.',
  'admin.setup.team.list': 'Platform super admins',
  'admin.setup.team.you': '(you)',
  'admin.setup.team.owner': 'Owner',
  'admin.setup.team.constel': 'Constel team',
  'admin.setup.team.transfer.open': 'Transfer ownership',
  'admin.setup.team.transfer.title': 'Transfer ownership',
  'admin.setup.team.transfer.description':
    'The person you choose becomes the platform owner. You remain a super admin, and they will be the one able to transfer this role later.',
  'admin.setup.team.transfer.candidates': 'New owner',
  'admin.setup.team.transfer.empty':
    'No super admin can become owner yet: invite someone and wait for them to activate their account.',
  'admin.setup.team.transfer.pendingHint': 'Only super admins who have activated their account can become owner.',
  'admin.setup.team.transfer.confirmWord': 'TRANSFER',
  'admin.setup.team.transfer.confirmLabel': 'Type {word} to confirm',
  'admin.setup.team.transfer.submit': 'Transfer',
  'admin.setup.team.transfer.submitTo': 'Transfer to {name}',
  'admin.setup.team.transfer.done': '{name} is now the platform owner',
  'admin.setup.team.transfer.error': 'The transfer failed. Try again.',
  'admin.setup.team.status.pending': 'Pending',
  'admin.setup.team.invitedAt': 'Invited {when}',
  'admin.setup.team.lastLogin': 'last signed in {when}',
  'admin.setup.team.neverLoggedIn': 'never signed in',
  'admin.setup.team.resend': 'Resend',
  'admin.setup.team.remove.label': 'Remove',
  'admin.setup.team.remove.cancelInvitation': 'Cancel',
  'admin.setup.team.remove.confirm': 'Confirm removal',
  'admin.setup.team.remove.cancel': 'Keep',
  'admin.setup.team.invited': 'Invitation sent | {count} invitations sent',
  'admin.setup.team.resent': 'Invitation sent again to {email}',
  'admin.setup.team.removed': '{email} is no longer a super admin',
  'admin.setup.team.errors.empty': 'Enter at least one email address.',
  'admin.setup.team.errors.invalid': 'Invalid address: {emails}',
  'admin.setup.team.errors.failed': 'These addresses could not be invited: {emails}',
  'admin.setup.team.errors.invite': 'The invitation failed. Check your connection, then try again.',
  'admin.setup.team.errors.resend': 'The invitation could not be sent again.',
  'admin.setup.team.errors.remove': 'Removal failed. Try again.',
  'admin.setup.team.errors.loading': 'Unable to load super admins.',
  'admin.setup.team.about.title': 'A super admin is someone who…',
  'admin.setup.team.about.allPrograms': 'can access every programme, including those created later;',
  'admin.setup.team.about.settings': 'configures the platform: appearance, sign-in, emails;',
  'admin.setup.team.about.impersonate': 'can sign in as a participant to help them;',
  'admin.setup.team.about.hidden': 'does not appear in programme user lists, nor to participants.',
  'admin.setup.team.about.oneProgram':
    'To give access to a single programme, invite an administrator or a manager from that programme instead.',
  'admin.setup.actions.back': 'Back',
  'admin.setup.actions.skip': 'Skip this step',
  'admin.setup.actions.continue': 'Continue',
  'admin.setup.identity.title': 'What is your platform called?',
  'admin.setup.identity.intro': 'The name participants see, and the name of your organization.',
  'admin.setup.identity.company.label': 'Organization name',
  'admin.setup.identity.company.description': 'Used in the legal notices and in the email signature.',
  'admin.setup.identity.platform.label': 'Platform name',
  'admin.setup.identity.platform.description': 'What participants see: browser tab, sign-in page, email subjects.',
  'admin.setup.branding.title': 'Make the platform yours',
  'admin.setup.branding.intro': 'The preview updates with every change. A program can later have its own colors.',
  'admin.setup.branding.logos.title': 'Logo',
  'admin.setup.branding.logo.description':
    'PNG, JPG or WebP, 2 MB max. Square if possible: it is also the browser tab icon. You can also drop the image on the thumbnail.',
  'admin.setup.branding.logo.choose': 'Choose a file',
  'admin.setup.branding.logo.replace': 'Replace',
  'admin.setup.branding.logo.remove': 'Remove',
  'admin.setup.branding.logo.uploading': 'Uploading the logo…',
  'admin.setup.branding.logo.errors.format': 'This format is not accepted: choose a PNG, JPG or WebP image.',
  'admin.setup.branding.logo.errors.size': 'The image is larger than 2 MB: shrink it and try again.',
  'admin.setup.branding.logo.errors.upload': 'Upload failed. Check your connection, then try again.',
  'admin.setup.branding.logo.default': 'Default',
  'admin.setup.branding.website.label': 'Get the logo and colors from your website',
  'admin.setup.branding.website.action': 'Get',
  'admin.setup.branding.website.hint': 'Paste your organization website address. You can adjust everything afterwards.',
  'admin.setup.branding.website.foundAll': 'Logo and colors retrieved. Check the preview before continuing.',
  'admin.setup.branding.website.foundColors':
    'Colors retrieved. No usable logo (PNG, JPG or WebP) on this site: upload it from your computer.',
  'admin.setup.branding.website.foundLogo': 'Logo retrieved. No colors found: choose them below.',
  'admin.setup.branding.website.nothing': 'Nothing usable on this site. Add the logo and colors by hand.',
  'admin.setup.branding.website.error': 'The website lookup failed. Add the logo and colors by hand.',
  'admin.setup.branding.customStyle.title': 'Custom style',
  'admin.setup.branding.customStyle.active': 'A custom CSS is applied to every page.',
  'admin.setup.branding.customStyle.label': 'CSS added to every page',
  'admin.setup.branding.customStyle.warning':
    'For fine adjustments only. This CSS applies to every page, for every participant, as soon as you save: a mistake can make the platform hard to use.',
  'admin.setup.branding.customStyle.description': 'For fine adjustments in CSS. Optional.',
  'admin.setup.branding.customStyle.show': 'Show the CSS',
  'admin.setup.branding.customStyle.hide': 'Hide the CSS',
  'admin.setup.branding.colors.title': 'Colors',
  'admin.setup.branding.primary.label': 'Primary color',
  'admin.setup.branding.secondary.label': 'Secondary color',
  'admin.setup.branding.contrastOk': 'Readable: white text on the primary color reaches {ratio}:1.',
  'admin.setup.branding.preview.caption': `Preview: your participants' sign-in page`,
  'admin.setup.branding.preview.login': 'Sign in',
  'admin.setup.branding.preview.email': 'Email address',
  'admin.setup.branding.preview.continue': 'Continue',
  'admin.setup.branding.preview.help': 'Need help?',
  'admin.setup.branding.preview.support': 'Contact support',
  'admin.setup.login.title': 'How do your participants sign in?',
  'admin.setup.login.intro':
    'You can keep both: SSO for participants from your organization, password for external mentors.',
  'admin.setup.login.email.title': 'Email and password',
  'admin.setup.login.email.description': 'Each participant receives an invitation and chooses a password.',
  'admin.setup.login.sso.title': 'Your organization SSO (SAML)',
  'admin.setup.login.sso.description':
    'Participants sign in with their usual account: Microsoft Entra, Google, Shibboleth.',
  'admin.setup.login.sso.modeLegend': 'Who sets up SSO?',
  'admin.setup.login.sso.itTeam.title': 'My IT team handles it',
  'admin.setup.login.sso.itTeam.description':
    'You send them the details to register. SSO stays off until the URL and certificate are filled in.',
  'admin.setup.login.sso.self.title': 'I set it up now',
  'admin.setup.login.sso.self.description': `Your provider's sign-in URL and certificate.`,
  'admin.setup.login.sp.title': 'To register with your identity provider',
  'admin.setup.login.sp.entityId': 'Entity ID',
  'admin.setup.login.sp.callback': 'Reply URL (ACS)',
  'admin.setup.login.sp.mailto': 'Draft the email to my IT team',
  'admin.setup.login.sp.subjectLabel': 'Subject',
  'admin.setup.login.sp.bodyLabel': 'Message',
  'admin.setup.login.sp.copy': 'Copy the message',
  'admin.setup.login.sp.copied': 'Message copied',
  'admin.setup.login.sp.openMailApp': 'Open in my mail app',
  'admin.setup.login.sp.mailSubject': 'SSO setup for the {platform} platform',
  'admin.setup.login.sp.mailBody': `Hello,\n\nWe are setting up our mentoring platform, {platform}. To enable SSO sign-in (SAML), could you register this application with our identity provider?\n\nEntity ID: {entityId}\nReply URL (ACS): {callback}\n\nIn return, we need the provider's SSO sign-in URL and its X.509 certificate.\n\nThank you!`,
  'admin.setup.login.ssoLogo.label': 'SSO sign-in button logo',
  'admin.setup.login.ssoLogo.description': 'PNG, JPG or WebP, 2 MB max.',
  'admin.setup.login.ssoLogo.preview': 'Button preview on the sign-in page',
  'admin.setup.login.ssoLogo.default':
    'By default, the button uses the platform logo. You can use another one, for example your identity provider logo.',
  'admin.setup.login.ssoLogo.custom': 'The button uses its own logo.',
  'admin.setup.login.ssoLogo.choose': 'Use another logo',
  'admin.setup.login.ssoLogo.reset': 'Back to the platform logo',
  'admin.setup.login.idpUrl.label': 'Provider sign-in URL (SSO URL)',
  'admin.setup.login.certificate.label': 'Provider certificate (X.509)',
  'admin.setup.login.certificate.description': 'Paste the full certificate, including the BEGIN and END lines.',
  'admin.setup.login.errors.noMethod':
    'Keep at least one sign-in method on: email, or an SSO with its URL and certificate filled in.',
  'admin.setup.contact.title': 'Who answers, and who is responsible for the data?',
  'admin.setup.contact.support.title': 'Contact for your participants',
  'admin.setup.contact.support.description': 'Shown under “Need help?” and at the bottom of every email.',
  'admin.setup.contact.supportEmail.label': 'Support email',
  'admin.setup.contact.supportPhone.label': 'Phone, optional',
  'admin.setup.contact.resources.label': 'Link to your resources, optional',
  'admin.setup.contact.resources.description': `A mentor guide, an intranet. It appears in participants' menu.`,
  'admin.setup.contact.legal.title': 'Data controller',
  'admin.setup.contact.legal.description':
    'Required by the GDPR. This completes the privacy policy that participants accept.',
  'admin.setup.contact.rtName.label': 'Organization',
  'admin.setup.contact.rtAddress.label': 'Postal address',
  'admin.setup.contact.dpoEmail.label': 'DPO email',
  'admin.setup.contact.legal.later': `Don't have this at hand? Skip the step. The platform stays usable, and this item will stay in your dashboard checklist.`,
  'admin.setup.recap.title': 'Your platform is almost ready',
  'admin.setup.recap.titleDone': 'Your platform is ready',
  'admin.setup.recap.intro':
    'What is missing does not prevent creating a program. It will stay in your dashboard checklist.',
  'admin.setup.recap.status.complete': 'Complete',
  'admin.setup.recap.status.todo': 'To complete',
  'admin.setup.recap.edit': 'Edit',
  'admin.setup.recap.next.title': 'Next step: your first program',
  'admin.setup.recap.next.description': 'Dates, matching criteria, session goals.',
  'admin.setup.recap.finish': 'Finish without a program',
  'admin.setup.recap.finishAndCreate': 'Finish and create a program',
  'admin.setup.nav.title': 'Getting started',
  'admin.setup.nav.progress': '{done} of {total} items',
  'admin.setup.nav.remaining': '{count} item left | {count} items left',
  'admin.setup.nav.done': 'Already set: {items}.',
  'admin.setup.checklist.items.identity': 'Name and organization',
  'admin.setup.checklist.items.branding': 'Logo and colors',
  'admin.setup.checklist.items.login': 'Sign-in method',
  'admin.setup.checklist.items.support': 'Support contact',
  'admin.setup.checklist.items.legal': 'Data controller and DPO',
} satisfies TranslationsFileType
